import React from "react";

import { cn } from "utils/cn";

export const ParkingLotStatusTagStyle = {
  FULL: "FULL",
  EMPTY: "EMPTY",
  AVAILABLE_SCHEDULE: "AVAILABLE_SCHEDULE",
  FULL_TEMPORARY: "FULL_TEMPORARY",
  FULL_PLAN_CANCEL: "FULL_PLAN_CANCEL",
  FULL_PLAN_END: "FULL_PLAN_END",
} as const;

export type ParkingLotStatusTagStyleType = (typeof ParkingLotStatusTagStyle)[keyof typeof ParkingLotStatusTagStyle];

const ParkingLotStatusTag = ({ style }: { style: ParkingLotStatusTagStyleType }) => {
  const styles = {
    [ParkingLotStatusTagStyle.FULL]: "bg-white border border-full text-full",
    [ParkingLotStatusTagStyle.FULL_PLAN_CANCEL]: "bg-white border border-full text-full",
    [ParkingLotStatusTagStyle.FULL_PLAN_END]: "bg-white border border-full text-full",
    [ParkingLotStatusTagStyle.AVAILABLE_SCHEDULE]: "bg-white border border-full text-full",
    [ParkingLotStatusTagStyle.FULL_TEMPORARY]: "bg-full text-white",
    [ParkingLotStatusTagStyle.EMPTY]: "bg-blue text-white",
  };

  const labels = {
    [ParkingLotStatusTagStyle.FULL]: "満車",
    [ParkingLotStatusTagStyle.FULL_PLAN_CANCEL]: "満車",
    [ParkingLotStatusTagStyle.FULL_PLAN_END]: "満車",
    [ParkingLotStatusTagStyle.AVAILABLE_SCHEDULE]: "満車",
    [ParkingLotStatusTagStyle.FULL_TEMPORARY]: "仮押さえ",
    [ParkingLotStatusTagStyle.EMPTY]: "空車",
  };

  return (
    <div className={cn("flex h-[24px] w-[62px] items-center justify-center rounded", styles[style])}>
      <span className="text-xs">{labels[style]}</span>
    </div>
  );
};

export default ParkingLotStatusTag;
